module.exports = __webpack_public_path__ + "img/nvidia.e6876a8f.svg";